import React from "react";
import { FileCopy } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/DeleteOutlined";
import SaveIcon from "@material-ui/icons/SaveAlt";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import EditIcon from "@material-ui/icons/EditOutlined";
import {
  DefaultRowButtonsConfig,
  SecuredMenuFunctionalButton,
  SecuredMenuLinkButton
} from "lego-gui-lib";
import { inject } from "mobx-react";
import { mainStore } from "../core/mainStore";
import { VisibilityType } from "./common";
const auth = mainStore.auth;

export const Button = inject("i18n")(
  ({ i18n: i18n, title: titleArgs, ...props }) => {
    const title = i18n.t(...titleArgs);
    return (
      <>
        {props.link ? (
          <SecuredMenuLinkButton title={title} {...props} />
        ) : (
          <SecuredMenuFunctionalButton title={title} {...props} />
        )}
      </>
    );
  }
);

export const CustomerAwareRowButtons = (
  indexProps: any,
  overrides?: Partial<DefaultRowButtonsConfig>
) => {
  return (row: any, key: string, close: () => void) => {
    const arr = [];
    const urlPrefix = indexProps.props.baseUrl || "";
    const onDelete = (e: any) => {
      indexProps.callbackDelete(row);
      close();
    };

    const onExport = (e: any) => {
      indexProps.props.dataSource.exportSelected("text/csv", row);
      close();
    };

    if (
      auth.isAdmin() ||
      (row.visibility !== VisibilityType.PUBLIC && !auth.isReadOnly())
    ) {
      if (overrides?.edit !== undefined) {
        arr.push(overrides.edit);
      } else {
        arr.push(
          <Button
            link={urlPrefix + indexProps.props.columns.link(row)}
            title={["lego:views.index.row.edit", "Edit"]}
            requiredAccess={"readable"}
            key={key + "edit"}
          >
            <EditIcon color={"inherit"} />
          </Button>
        );
      }

      if (overrides?.delete !== undefined) {
        arr.push(overrides.delete);
      } else {
        arr.push(
          <Button
            callbackFunction={onDelete}
            title={["lego:views.index.row.delete", "Delete"]}
            key={key + "delete"}
          >
            <DeleteIcon />
          </Button>
        );
      }
    } else {
      if (overrides?.edit !== undefined) {
        arr.push(overrides.edit);
      } else {
        arr.push(
          <Button
            link={urlPrefix + indexProps.props.columns.link(row)}
            title={["lego:views.index.row.view", "View"]}
            requiredAccess={"readable"}
            key={key + "show"}
          >
            <DescriptionOutlinedIcon color={"inherit"} />
          </Button>
        );
      }
    }

    if (overrides?.copy !== undefined) {
      arr.push(overrides.copy);
    } else {
      arr.push(
        <Button
          link={urlPrefix + "/create" + indexProps.props.columns.link(row)}
          title={["lego:views.index.row.copy", "Copy"]}
          requiredAccess={"editable"}
          key={key + "copy"}
        >
          <FileCopy />
        </Button>
      );
    }

    if (overrides?.export !== undefined) {
      arr.push(overrides.export);
    } else {
      arr.push(
        <Button
          callbackFunction={onExport}
          title={["lego:views.index.row.export", "Export"]}
          key={key + "export"}
        >
          <SaveIcon />
        </Button>
      );
    }

    return arr;
  };
};

export const customRowButtonsForNestedIndex = (
  indexProps: any,
  allowed: any,
  overrides?: Partial<DefaultRowButtonsConfig>
) => (row: any, key: string, close: () => void) => {
  const arr = [];
  const onDelete = (e: any) => {
    indexProps.callbackDelete(row);
    close();
  };
  const urlPrefix = indexProps.props.baseUrl || "";

  if (allowed) {
    arr.push(
      <Button
        link={urlPrefix + indexProps.props.columns.link(row)}
        title={["lego:views.index.row.edit"]}
        requiredAccess={"editable"}
        key={key + "edit"}
      >
        <EditIcon color={"inherit"} />
      </Button>
    );
    arr.push(
      <Button
        callbackFunction={onDelete}
        title={["lego:views.index.row.delete", "Delete"]}
        requiredAccess={"editable"}
        key={key + "delete"}
      >
        <DeleteIcon />
      </Button>
    );

    // for now new only copy option override
    if (overrides?.copy !== false) {
      arr.push(
        <Button
          link={urlPrefix + "/create" + indexProps.props.columns.link(row)}
          title={["lego:views.index.row.copy", "Copy"]}
          requiredAccess={"editable"}
          key={key + "copy"}
        >
          <FileCopy />
        </Button>
      );
    }
  } else {
    arr.push(
      <Button
        link={urlPrefix + indexProps.props.columns.link(row)}
        title={["lego:views.index.row.view", "View"]}
        requiredAccess={"readable"}
        key={key + "show"}
      >
        <DescriptionOutlinedIcon color={"inherit"} />
      </Button>
    );
  }

  return arr;
};
